'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { getCookie } from 'cookies-next';
import sendGoogleConsent from '@utils/gtm/gtm';
import { CookieConsentModal } from '@components/features/modals/cookie-consent-modal';

export const CookieConsent = () => {
  const [cookieConsent, setCookieConsent] = useState(true);
  const pathname = usePathname(); // Track current route

  const onCookieConsent = () => {
    setCookieConsent(true);
    // Read what the modal/storage just set (adapt keys if needed)
    const adConsent = getCookie('cc_ads') === 'granted' ? 'granted' : 'denied';
    const analyticsConsent = getCookie('cc_analytics') === 'granted' ? 'granted' : 'denied';

    // Push a full update immediately
    sendGoogleConsent({
      ad_storage: adConsent,
      analytics_storage: analyticsConsent,
      ad_user_data: adConsent,
      ad_personalization: adConsent,
      functionality_storage: 'granted',
      personalization_storage: 'granted',
      security_storage: 'granted',
    });
  };

  const onDismiss = () => {
    setCookieConsent(true); // hide the modal only
  };

  useEffect(() => {
    // Check if user has previously set consent
    const hasConsent = window.localStorage.getItem('cc_ts') !== null || getCookie('cc_ts') !== undefined;

    if (hasConsent) {
      setCookieConsent(true);

      // Re-apply stored consent on route changes (for client-side navigation)
      const adConsent = getCookie('cc_ads') === 'granted' ? 'granted' : 'denied';
      const analyticsConsent = getCookie('cc_analytics') === 'granted' ? 'granted' : 'denied';

      const timer = setTimeout(() => {
        sendGoogleConsent({
          ad_storage: adConsent,
          analytics_storage: analyticsConsent,
          ad_user_data: adConsent,
          ad_personalization: adConsent,
          functionality_storage: 'granted',
          personalization_storage: 'granted',
          security_storage: 'granted',
        });
      }, 100);

      return () => clearTimeout(timer);
    }

    // No consent stored - show banner
    setCookieConsent(false);
    return undefined;
  }, [pathname]);


  return (
    <CookieConsentModal
      isOpen={!cookieConsent}
      onConsent={onCookieConsent}
      cookiesBlocked={false}
      onClose={onDismiss}
    />
  );
};
